// Aula virtual //

export const CaracteristicasAulaVirtual = [
  "Ficha Del Curso Individual Personalizado (ACF)",
  "Integracion Por Zoom/Google Para Clases En Vivo",
  "Subida De Cursos Con Videos, PDFs, Imágenes",
  "Tipos De Preguntas (Opción Múltiple, Verdadero/Falso, Ensayo, Rellenar Espacios, Subir Archivos)",
  "Exámenes Cronometrados",
  "Certificados Con Código QR",
  "Certificados En PDF",
  "Generación Automática De Diplomas Al Completar El Curso",
  "Verificación De Certificados Online (Búsqueda Por DNI O Código De Certificado)",
  "Integración Con Plugins De Membresía (Memberpress, Paid Memberships Pro, Restrict Content Pro, Etc.)",
  "Foros De Discusión (Bbpress, Buddypress, Asgaros Forum)",
  "Sistema De Preguntas Y Respuestas Entre Alumnos E Instructores",
  "Panel De Administración Para Instructores (Subida De Cursos, Reportes, Interacción Con Alumnos) Sin Acceder A Wordpress",
  "Gestión De Múltiples Instructores Por Curso",
  "Pagos Automáticos A Profesores (Si Aplica Marketplace De Cursos)",
  "Control De Asistencia Para Clases En Vivo (Docente Toma Asistencia)",
  "Control De Asistencia Para Clases En Vivo (Alumno Marca Asistencia)",
  "Registro De Alumnos Con Google, Facebook O LinkedIn",
  "Perfiles De Usuario Personalizados Y Permisos Avanzados (Alumnos, Profesores, Administradores)",
  "Aula Virtual, Sistema de Pagos Mensuales para los alumnos (Suscripción)"
]

export const CaracteristicasAulaVirtualIntermedio = [
  "Ficha Del Curso Individual Personalizado (ACF)",
  "Subida De Cursos Con Videos, PDFs, Imágenes",
  "Tipos De Preguntas (Opción Múltiple, Verdadero/Falso, Ensayo, Rellenar Espacios, Subir Archivos)",
  "Certificados En PDF",
  "Generación Automática De Diplomas Al Completar El Curso",
  "Integración Con Plugins De Membresía (Memberpress, Paid Memberships Pro, Restrict Content Pro, Etc.)",
  "Sistema De Preguntas Y Respuestas Entre Alumnos E Instructores",
  "Panel De Administración Para Instructores (Subida De Cursos, Reportes, Interacción Con Alumnos) Sin Acceder A Wordpress",
  "Control De Asistencia Para Clases En Vivo (Alumno Marca Asistencia)",
  "Perfiles De Usuario Personalizados Y Permisos Avanzados (Alumnos, Profesores, Administradores)",
]

export const CaracteristicasAulaVirtualBasico = [
  "Subida De Cursos Con Videos, PDFs, Imágenes",
  "Certificados En PDF",
  "Sistema De Preguntas Y Respuestas Entre Alumnos E Instructores",
]


// Tienda virtual // 
  
export const CaracteristicasTiendaVirtual = [
  "Búsqueda Ajax Con Imágenes Y Precios",
  "Filtros Dinámicos Por Precio, Categoría Y Atributos",
  "Checkout Personalizado",
  "Compra Directa Sin Pasar Por El Carrito",
  "Ofertas Irresistibles Con Popups Personalizados",
  "Creación De Cupones Programados",
  "Fichas De Producto Con Campos Personalizados (ACF)",
  "Variaciones De Productos Individuales Con Imágenes",
  "Notificaciones En Vivo De Compras Recientes",
  "Reseñas Avanzadas (Del Usuario) Con Imágenes Y Videos",
  "Integración Con Izipay Y Otros Métodos Locales",
  "Pasarela De Pagos Con QR Y Código Dinámico",
  "Pasarela De Pagos Con QR Estándar",
  "Personalización Del Costo De Envío Según Ubicación Del Usuario",
  "Control De Inventario Con Alertas De Stock Bajo",
  "Tarifas De Envío Dinámicas Según Peso Y Destino",
  "Integración Con Empresas De Mensajería Para Cálculo De Envíos",
  "Confirmación De Pedido Con Detalles (Para El Que Compra)",
  "Comparador De Productos Para Ayudar A La Decisión De Compra",
  "Lista De Deseos Para Que Los Clientes Guarden Productos Favoritos",
  "Notificaciones De Stock Repuesto Para Productos Agotados",
  "Registro De Clientes Con Google, Facebook O LinkedIn",
]

export const CaracteristicasTiendaVirtualIntermedio = [
  "Búsqueda Ajax Con Imágenes Y Precios",
  "Filtros Dinámicos Por Precio, Categoría Y Atributos",
  "Checkout Personalizado",
  "Ofertas Irresistibles Con Popups Personalizados",
  "Creación De Cupones Programados",
  "Fichas De Producto Con Campos Personalizados (ACF)",
  "Notificaciones En Vivo De Compras Recientes",
  "Reseñas Avanzadas (Del Usuario) Con Imágenes Y Videos",
  "Integración Con Izipay Y Otros Métodos Locales",
  "Pasarela De Pagos Con QR Y Código Dinámico",
  "Pasarela De Pagos Con QR Estándar",
  "Personalización Del Costo De Envío Según Ubicación Del Usuario",
  "Confirmación De Pedido Con Detalles (Para El Que Compra)",
  "Comparador De Productos Para Ayudar A La Decisión De Compra",
  "Lista De Deseos Para Que Los Clientes Guarden Productos Favoritos",
  "Notificaciones De Stock Repuesto Para Productos Agotados",

]

export const CaracteristicasTiendaVirtualBasico = [
  "Filtros Dinámicos Por Precio, Categoría Y Atributos",
  "Creación De Cupones Programados",
  "Integración Con Izipay Y Otros Métodos Locales",
  "Pasarela De Pagos Con QR Estándar",
  "Lista De Deseos Para Que Los Clientes Guarden Productos Favoritos",
  "Notificaciones De Stock Repuesto Para Productos Agotados",
]


// Web informativa //

export const CaracteristicasWebInformativa = [
  "Banners Interactivos",
  "Banners Estáticos",
  "Configuración De Google My Business",
  "Estructura Optimizada Para SEO (Breadcrumbs, Metaetiquetas, URL Amigables)",
  "Vinculación De Formularios Con Base De Datos (Google Sheet)",
  "Integración Con WhatsApp Botón Para Atención Directa Con URL Personalizada",
  "Chat En Vivo Con Automatización Y Bots De Respuestas Rápidas",
  "Pestaña Individual Por Servicio",
  "Pestaña De Nosotros",
  "Pestaña De Contacto",
  "Pestaña De Proyectos O Galerías",
  "Pestaña De Blog",
  "Pestaña De Publicaciones (Artículos, Reportes) De La Empresa",
  "Pestaña De Trabaja Con Nosotros",
  "Libro De Reclamaciones, Términos Y Condiciones Y Política De Privacidad",
  "Sesión De Clientes Satisfechos (Fotos O Videos)",
  "Sesión De Equipo De Trabajo (Fotos O Videos)",
]

export const CaracteristicasWebInformativaIntermedia = [
  "Banners Interactivos",
  "Banners Estáticos",
  "Vinculación De Formularios Con Base De Datos (Google Sheet)",
  "Integración Con WhatsApp Botón Para Atención Directa Con URL Personalizada",
  "Pestaña Individual Por Servicio",
  "Pestaña De Nosotros",
  "Pestaña De Contacto",
  "Pestaña De Proyectos O Galerías",
  "Pestaña De Blog",
  "Pestaña De Publicaciones (Artículos, Reportes) De La Empresa",
  "Pestaña De Trabaja Con Nosotros",
  "Libro De Reclamaciones, Términos Y Condiciones Y Política De Privacidad",
  "Sesión De Clientes Satisfechos (Fotos O Videos)",
  "Sesión De Equipo De Trabajo (Fotos O Videos)",
]

export const CaracteristicasWebInformativaBasica = [
  "Banners Estáticos",
  "Integración Con WhatsApp Botón Para Atención Directa Con URL Personalizada",
  "Pestaña Individual Por Servicio",
  "Pestaña De Nosotros",
  "Pestaña De Contacto",
  "Libro De Reclamaciones, Términos Y Condiciones Y Política De Privacidad",
]


// Características adicionales //

export const CaracteristicasAdicionales = [
  "Mensaje personalizado en la pestaña vuelve y gracias por volver",
  "Multidiomas con google",
  "Multidiomas con con cambio de url",
  "Web en Multimonedas",
  "Calculadora",
  "Sistema de reservas",
  "Un espacio donde puedan descargar imagenes o videos",
  "Pestaña con guia de tallas por producto individual",
  "Calendario de eventos",
  "Notificar a los alumnos/usuarios de los eventos",
  "Usuarios especificos pueden comprar productos vip, los usuarios normales no",
  "Notificar a los clientes si un producto vuelve a tener stock",
  "Bloquear usuarios confligtivos (si no pago, si es spam)",
  "Diferente precio por rol de usuario",
  "Metricas de evaluacion de ventas (woo) y de visitas (sitekit)"
]

export const CaracteristicasAdicionalesIntermedio = [
  "Mensaje personalizado en la pestaña vuelve y gracias por volver",
  "Multidiomas con google",
  "Calculadora",
  "Sistema de reservas",
  "Un espacio donde puedan descargar imagenes o videos",
  "Pestaña con guia de tallas por producto individual",
  "Calendario de eventos",
  "Notificar a los clientes si un producto vuelve a tener stock",
  "Bloquear usuarios confligtivos (si no pago, si es spam)",
  "Metricas de evaluacion de ventas (woo) y de visitas (sitekit)"
]

export const CaracteristicasAdicionalesBasico = [
  "Multidiomas con google",
]